import { render, staticRenderFns } from "./friendsLinkEdit.vue?vue&type=template&id=648acb29&scoped=true"
import script from "./friendsLinkEdit.vue?vue&type=script&lang=js"
export * from "./friendsLinkEdit.vue?vue&type=script&lang=js"
import style0 from "./friendsLinkEdit.vue?vue&type=style&index=0&id=648acb29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648acb29",
  null
  
)

export default component.exports